import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

export default function DownloadConfirmDialog({
  open,
  message,
  onCancel,
  onProceed,
}) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Download confirmation</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onProceed}
          variant="contained"
          color="primary"
        >
          Download
        </Button>
        <Button
          onClick={onCancel}
          variant="contained"
          color="secondary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
